module.exports = __webpack_public_path__ + "static/media/stats-02.34433e46.jpg";